export default (userAgent = window.navigator.userAgent) => {
  const CRAWLER_PATTERN = /Google|bot|crawl|spider/;

  return CRAWLER_PATTERN.test(userAgent);
};
